var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('iframe',{style:(_vm.iFrameStyle),attrs:{"id":("grab-" + _vm.id),"height":_vm.properties.grabHeight,"src":_vm.properties.url,"width":_vm.properties.grabWidth,"scrolling":"no"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }